
  import * as vercelRuntime$_FtEY1C1me3ziGvTCCAlMHD7Sai_VJd2MIbGRMHtz28 from '/vercel/path0/src/node_modules/@nuxt/image/dist/runtime/providers/vercel'
  
  export const imageOptions = {
    ...{
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "vercel",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
},
    providers: {
        ['vercel']: { provider: vercelRuntime$_FtEY1C1me3ziGvTCCAlMHD7Sai_VJd2MIbGRMHtz28, defaults: {} }
    }
  }
